document.addEventListener("DOMContentLoaded", function(e) {
    var campaignDropdown = document.getElementById("campaign-dropdown");
    if (campaignDropdown) {
        campaignDropdown.addEventListener("click", function(e) {
            e.stopPropagation();
            var ul = document.getElementById("campaign-list");
            var selector = document.getElementById("campaign-selector");
            if (ul.style.display == "block") {
                ul.style.display = "none";
                selector.classList.remove("campaign-selector--opened");
                selector.setAttribute("aria-expanded", "false");
            } else {
                ul.style.display = "block";
                selector.classList.add("campaign-selector--opened");
                selector.setAttribute("aria-expanded", "true");
            }
        });
    }
});

window.onclick = function(event) {
    var ul = document.getElementById("campaign-list");
    var selector = document.getElementById("campaign-selector");
    if (ul) {
        ul.style.display = "none";
    }
    if (selector) {
        selector.setAttribute("aria-expanded", "false");
        selector.classList.remove("campaign-selector--opened");
    }     
}